import { Component, OnInit, Input } from '@angular/core';
import { NbStepperComponent, NbDialogService, NbToastrService } from '@nebular/theme';
import { ConversionData } from 'src/app/models/conversion.model';
import { Conversion } from 'src/app/models/conversion.model';
import { HttpClient } from '@angular/common/http';
import { getTotalCreditCount, User } from 'src/app/models/users.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ConversionDetailsComponent } from 'src/app/shared/ui/conversion-details/conversion-details.component';

@Component({
  selector: 'app-convert-3',
  templateUrl: './convert-3.component.html',
  styleUrls: ['./convert-3.component.scss'],
})
export class Convert3Component implements OnInit {
  @Input()
  conversionData: ConversionData;
  @Input()
  stepper: NbStepperComponent;

  user: User;

  /** Keyed rows — updates don't destroy/recreate row components (prevents flicker) */
  trackByUid(index: number, item: { uid?: string }): string | number {
    return item?.uid || index;
  }

  constructor(
    private ss: SharedService,
    private dialogService: NbDialogService,
    private http: HttpClient,
    private toastr: NbToastrService,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();
    if (this.conversionData.convertedFiles.find((a) => !a.healthCheck || !a.healthCheck.healthy)) {
      const failedIndices = this.conversionData.convertedFiles
        .map((a, index) => (a.healthCheck && a.healthCheck.healthy ? null : index))
        .filter((a) => a != null);
      let refundedCount = 0;
      failedIndices.forEach((index) => (refundedCount += this.conversionData.files[index].pageCount));
      this.toastr.warning(
        `We ran in to some issues converting your statements. We will
         get back to you with the corrected files or refund you within a few hours.`,
        `${getTotalCreditCount(this.user)} Credits Remaining`,
        { duration: 10000 },
      );
    } else {
      this.toastr.success(`Successfully converted your documents`, `${getTotalCreditCount(this.user)} Credits Remaining`);
    }
  }

  viewDetailsClicked(c: Conversion) {
    this.dialogService.open(ConversionDetailsComponent, {
      context: {
        conversion: c,
      },
    });
  }
}
